<template>
  <confirm-modal
    ref="modal"
    title="Удаление адреса"
    confirm="Удалить"
    reset="Отменить"
    mode="danger"
    :modal="true"
  >
    <Loader
      v-if="busy"
      class="loader"
      label="Данные загружаются"
      height="120"
      :active="true"
    />
    <template v-else-if="data">
      Адрес
      <strong v-if="data.type === 'address'">
        {{ [data.address.city, data.address.street, data.address.home, data.address.housing].filter(Boolean).join(", ") }}
      </strong>
      <span v-else>
        <strong>
          {{ data.zone.name }}
        </strong>
        (<a :href="data.zone.url" target="_blank">
          {{ data.zone.url }}
        </a>)
      </span>
      будет удален без возможности восстановления
    </template>
  </confirm-modal>
</template>

<script>
import api from "@/plugins/api";

import ConfirmModal from "@/components/modals/confirm-modal/index.vue";
import Loader from "@/components/loader.vue";

export default {
  components: {
    ConfirmModal,
    Loader,
  },
  data: () => ({
    busy: false,
    id: null,
    data: null,
  }),
  methods: {
    async open (id) {
      if (!id) {
        return;
      }

      this.id = id;

      this.busy = true;

      try {
        this.$refs.modal.open({
          onConfirm: this.confirm,
        });

        const { data } = await api.get("bad-address/view", {
          params: {
            id,
          }
        });

        this.data = data;
      } catch (error) {
        console.error(error);
        this.close();
      }
      
      this.busy = false;
    },
    close () {
      this.$refs.modal.close();

      this.id = null;
      this.data = null;
    },
    async confirm () {
      this.busy = true;

      try {
        await api.delete("bad-address/delete", {
          params: {
            id: this.id,
          }
        });

        this.$emit("remove", this.data);
        this.close();
      } catch (error) {
        console.error(error);
      }

      this.busy = false;
    },
  },
};
</script>

<style lang="scss" scoped>
a {
  word-break: break-word;
}
</style>